(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxs-shop-this-look"] && !Shopify.designMode) return;
  try {
    

// SHOP THIS LOOK JS FUNCTIONALITIES.

document.addEventListener('DOMContentLoaded', function () {

  const triggerBtn = document.getElementById('drawer-trigger');
  const closeBtn = document.getElementById('drawer-close');
  const drawer = document.getElementById('sliding-drawer');
  const overlay = document.getElementById('drawer-overlay');


  // Filter layouts
  const btnGrid = document.getElementById('toggle-grid-view');
  const btnList = document.getElementById('toggle-list-view');
  const productGrid = document.querySelector('.drawer-product-grid');

  if (triggerBtn) {
    triggerBtn.addEventListener('click', function () {
      if (overlay) {
        overlay.style.display = 'block';
        setTimeout(() => {
          // Fade layer to opacity 1 smoothly
          overlay.classList.add('is-visible'); 
        }, 10);
      }
      
      // Freezes scrolling globally across desktop and safari mobile viewports
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden'; 
      
      if (drawer) drawer.classList.add('is-open');
    });
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    
    // Hold execution context exactly 400ms matching CSS transition curve speeds
    setTimeout(() => {
      if (overlay) overlay.style.display = 'none';
      
      // Restores standard scrolling boundaries smoothly
      document.body.style.overflow = ''; 
      document.documentElement.style.overflow = '';
    }, 400);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (btnGrid && btnList && productGrid) {
    // Toggle List View
    btnList.addEventListener('click', function() {
      productGrid.classList.add('is-list-view');
      btnList.classList.add('is-active');
      btnGrid.classList.remove('is-active');
    });

    // Toggle Grid View
    btnGrid.addEventListener('click', function() {
      productGrid.classList.remove('is-list-view');
      btnGrid.classList.add('is-active');
      btnList.classList.remove('is-active');
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["standard-banner"] && !Shopify.designMode) return;
  try {
    

// SHOP THIS LOOK JS FUNCTIONALITIES.

document.addEventListener('DOMContentLoaded', function () {
  
  // Find all banner components on the page
  const banners = document.querySelectorAll('.responsive-image');

  banners.forEach(function (banner) {
    const sectionId = banner.getAttribute('data-section-id');
    if (!sectionId) return;

    // Find the button inside the banner
    const triggerBtn = banner.querySelector('.drawer-trigger');
    
    // Find matching sibling containers using the section ID data attributes
    const drawer = document.querySelector(`.sliding-drawer[data-section-id="${sectionId}"]`);
    const overlay = document.querySelector(`.drawer-overlay[data-section-id="${sectionId}"]`);

    if (!drawer || !overlay) return;

    // Find dynamic controls inside our matched drawer
    const closeBtn = drawer.querySelector('.sliding-drawer__close');
    const btnGrid = drawer.querySelector('.toggle-grid-view');
    const btnList = drawer.querySelector('.toggle-list-view');
    const productGrid = drawer.querySelector('.drawer-product-grid');

    if (triggerBtn) {
      triggerBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        overlay.style.display = 'block';
        setTimeout(() => {
          overlay.classList.add('is-visible'); 
        }, 10);
        
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden'; 
        drawer.classList.add('is-open');
      });
    }

    function closeDrawer(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      
      setTimeout(() => {
        overlay.style.display = 'none';
        document.body.style.overflow = ''; 
        document.documentElement.style.overflow = '';
      }, 400);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Layout Toggle Switch
    if (btnGrid && btnList && productGrid) {
      btnList.addEventListener('click', function(e) {
        e.preventDefault();
        productGrid.classList.add('is-list-view');
        btnList.classList.add('is-active');
        btnGrid.classList.remove('is-active');
      });

      btnGrid.addEventListener('click', function(e) {
        e.preventDefault();
        productGrid.classList.remove('is-list-view');
        btnGrid.classList.add('is-active');
        btnList.classList.remove('is-active');
      });
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
